var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Adendo_ColaboradorActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Adendo_ColaboradorModule = class Adendo_ColaboradorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Adendo_ColaboradorActions.POST_ADENDO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.post("Adendo_Colaborador/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Adendo_ColaboradorActions.PUT_ADENDO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.put("Adendo_Colaborador/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Adendo_ColaboradorActions.DELETE_ADENDO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.delete("Adendo_Colaborador/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Adendo_ColaboradorActions.DELETE_RANGE_ADENDO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.delete("Adendo_Colaborador/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Adendo_ColaboradorActions.FILTER_ADENDO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.post("Adendo_Colaborador/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Adendo_ColaboradorActions.GET_ADENDO_COLABORADOR]() {
        return new Promise(resolve => {
            fornecService.get("Adendo_Colaborador/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Adendo_ColaboradorActions.GETWITHDISABLED_ADENDO_COLABORADOR]() {
        return new Promise(resolve => {
            fornecService.get("Adendo_Colaborador/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Adendo_ColaboradorActions.GET_ADENDO_COLABORADOR_POR_PROJETO](data) {
        return new Promise(resolve => {
            fornecService.get("Adendo_Colaborador/GetPorProjeto", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Adendo_ColaboradorActions.GET_BY_ID_ADENDO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.get("Adendo_Colaborador/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Adendo_ColaboradorActions.GET_BY_DATE_ADENDO_COLABORADOR](data) {
        return new Promise(resolve => {
            fornecService.post("Adendo_Colaborador/GetWithDisabledByDate", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Adendo_ColaboradorModule.prototype, _k, null);
Adendo_ColaboradorModule = __decorate([
    Module
], Adendo_ColaboradorModule);
export default Adendo_ColaboradorModule;
//# sourceMappingURL=Adendo_ColaboradorModule.js.map